import { HubConnection, HubConnectionBuilder } from "@microsoft/signalr";

let connection: HubConnection | null = null;

/**
 * Returns a singleton HubConnection.  Starts it exactly once.
 */
export function getSignalRConnection(): HubConnection {
  if (!connection) {
    connection = new HubConnectionBuilder()
      .withUrl(`${process.env.REACT_APP_BST_INSIGHTS_URL}/userHub`)
      .withAutomaticReconnect()
      .build();

    connection
      .start()
      .then(() => console.debug("SignalR connected"))
      .catch((err) => console.error("SignalR Connection Error:", err));
  }
  return connection;
}
